// Shared shape for the company creation wizard form state.

export interface CompanyCreationData {
  /** Object URL of the chosen logo preview. */
  logo: string | null;
  logoName: string;
  /** The raw file, retained for the presigned upload on submit. */
  logoFile: File | null;
  companyName: string;
  role: string;
  email: string;
  employeeRange: string;
  industry: string;
  features: string[];
}

export const initialCompanyCreationData: CompanyCreationData = {
  logo: null,
  logoName: '',
  logoFile: null,
  companyName: '',
  role: '',
  email: '',
  employeeRange: '',
  industry: '',
  features: [],
};
